/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductDocument
 */
export interface ProductDocument {
    /**
     * 
     * @type {string}
     * @memberof ProductDocument
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDocument
     */
    url?: string;
}

/**
 * Check if a given object implements the ProductDocument interface.
 */
export function instanceOfProductDocument(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductDocumentFromJSON(json: any): ProductDocument {
    return ProductDocumentFromJSONTyped(json, false);
}

export function ProductDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductDocument {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function ProductDocumentToJSON(value?: ProductDocument | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'url': value.url,
    };
}

